export const MOBILE_BREAKPOINT_PX = 550
export const MOBILE_MEDIA_QUERY = `@media screen and (max-width: ${MOBILE_BREAKPOINT_PX}px)`

export const HIDE_SCROLLBAR_STYLE = {
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '::-webkit-scrollbar': {
    display: 'none',
  },
} as const
